import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "main-components-container" }
const _hoisted_3 = { class: "component-container-max-height" }
const _hoisted_4 = {
  key: 0,
  class: "component-container"
}
const _hoisted_5 = { class: "component-container-main-view" }

import { computed } from 'vue';
import { onMounted } from 'vue';
import { useStore } from 'vuex';

import '@rednex/gateway_core/dayjs';
//### Function imports

//### Service imports
//--- Service imports

//### Model imports
//--- Model imports

//### Component imports
import NavigationBar from '@/core/navigation-bar/navigation-bar.vue';
import Sidebar from '@/core/sidebar/sidebar.vue';
//--- Component imports

//### External Properties
//--- External Properties

//### Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

//### Function imports
const store = useStore();
//--- Setup

//### Store/Reactive Data
const extendedSearchComponentVisible = computed(() => store.getters.extendedSearchComponentVisible);
const inList = computed(() => store.getters.inList);
const isAuthenticated = computed(() => store.getters.isAuthenticated);
const isInImpersonateMode = computed(() => store.getters.isInImpersonateMode);
const isPhoneDevice = computed(() => store.getters.isPhoneDevice);
const isTabletDevice = computed(() => store.getters.isTabletDevice);
const menuExpanded = computed(() => store.getters.menuExpanded);
const salesMode = computed(() => store.getters.salesMode);
const themeMode = computed(() => store.getters.themeMode);
//--- Store/Reactive Data

//### Variables const let
let ctxExtendedSearch;
//--- Variables const let

//### Component Lifecycle
onMounted(() => {
  refreshTheme();
});
//--- Component Lifecycle

//### Functions
function refreshTheme() {
  themeMode.value === 'dark' ? require('@content/scss/rs-theme/rs-theme-dark.scss') : require('@content/scss/rs-theme/rs-theme.scss');
}
//--- Functions

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`${isAuthenticated.value && !salesMode.value ? (menuExpanded.value ? 'menu-expanded-wrapper' : 'menu-hidden-wrapper') : ''}
      ${isTabletDevice.value || isPhoneDevice.value ? 'mobile-view' : ''} ${isInImpersonateMode.value ? 'impersonate-mode' : ''}`)
    }, [
      (isAuthenticated.value && !salesMode.value)
        ? (_openBlock(), _createBlock(Sidebar, { key: 0 }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        (isAuthenticated.value)
          ? (_openBlock(), _createBlock(NavigationBar, { key: 0 }))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: _normalizeClass(`main-component-view ${!isAuthenticated.value ? 'main-component-not-authenticated' : ''}`)
        }, [
          _createElementVNode("div", _hoisted_3, [
            (isAuthenticated.value && extendedSearchComponentVisible.value && inList.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_unref(ctxExtendedSearch))
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_view)
            ])
          ])
        ], 2 /* CLASS */)
      ])
    ], 2 /* CLASS */),
    _createVNode(_component_Toast, { baseZIndex: 10000 })
  ]))
}
}

})